import React from "react";
import useAccountRiskLimits from '../../utils/risklimits'
import { Warn } from '../common/Warn'
import { Box, Text } from "grommet"
import AgDataTable from '../common/AgDataTable'
import { useMarket } from '../../utils/market'


export const AccountRiskLimits = ({ accountId }) => {

    const accountRiskLookup = useAccountRiskLimits(accountId)
    const marketLookup = useMarket()

    const tab_col4 = [
        {
            field: "instId",
            headerName: "ID",
            minWidth: 150,

        },
        {
            field: "exchangeId",
            headerName: "Exchange",
            minWidth: 150,
        },
        {
            field: "prodType",
            headerName: "Prod Type",
            minWidth: 150,
        },
        {
            field: "maxPosProdNett",
            headerName: "Max Position product (nett)",
            minWidth: 150,
        },
        {
            field: "maxLongPosContract",
            headerName: "Max long postition per contract",
            minWidth: 150,
        },
        {
            field: "maxShortPosContract",
            headerName: "Max short postion per contract",
            minWidth: 150,
        },
        {
            field: "maxLongPositionGross",
            headerName: "Max long position (gross)",
            minWidth: 150,
        },
        {
            field: "maxShortPositionGross",
            headerName: "Max short position (gross)",
            minWidth: 150,
        },
        {
            field: "allowTradeOut",
            headerName: "Trade out allowed",
            hide: true
        },
        {
            field: "allowOutrightTrade",
            headerName: "Outright Trading Allowed",
            hide: true
        },
        {
            field: "allowOutrightCancel",
            headerName: "Outright Cancel Allowed",
            hide: true
        },
        {
            field: "outrightMaxOrderQuantity",
            headerName: "Outright Max order quantity",
            hide: true
        },
        {
            field: "outrightAppliedMargin",
            headerName: "Outright applied margin %",
            hide: true
        },
        {
            field: "spreadStrategyTradAllow",
            headerName: "Spread / Strategy Trading allowed",
            minWidth: 150,
        },
        {
            field: "spreadStrategyMaxOrderQty",
            headerName: "Spread / Strategy Max Order quantity",
            minWidth: 150,
        },
        {
            field: "spreadStrategyMargin",
            headerName: "Spread / Strategy applied margin %",
            minWidth: 150,
        },
        {
            field: "whOutrightTradeAllow",
            headerName: "Wh Outright Trading allowed",
            hide: true
        },
        {
            field: "whOutrightCancelAllow",
            headerName: "Wh Outright Cancel allowed",
            hide: true
        },
        {
            field: "whOutRightMaxOrderQty",
            headerName: "Wh Outright max Order quantity",
            hide: true
        },
    ]

    let limitSettings = {}
    let tab_data4 = []

    //https://pds-ext-prod-live.trade.tt/api/1/systemdata?type=producttype
    const prod_type_matrix = {
        17: "Corporate Bond",
        20: "Common Stock",
        33: "Forward",
        34: "Future",
        43: "Spread",
        51: "Option",
        77: "US Treasury Bond",
        119: "Index",
        200: "Option Strategy",
        202: "Spot",
        203: "Currency",
    }

    function get_prod_type(prod_type_num) {
        let val = prod_type_matrix[prod_type_num]
        if (val)
            return val
        else
            return prod_type_num
    }

    if (accountRiskLookup && accountId && Object.keys(accountRiskLookup).length > 0) {

        if (accountRiskLookup.oLimitSettings) {
            const bNoLimits = accountRiskLookup.oLimitSettings.bNoLimits === 1 ? "No" : "Yes"
            const bApplyLimitsWholesale = accountRiskLookup.oLimitSettings.bApplyLimitsWholesale === 1 ? "Yes" : "No"
            limitSettings =
            {
                'applyLimits': bNoLimits,
                'applyWholesaleLimits': bApplyLimitsWholesale,
            }
        }

        if (accountRiskLookup.oRiskLimits && accountRiskLookup.oRiskLimits.aProductLimits) {
            for (const [prodLimitNo, limit] of Object.entries(accountRiskLookup.oRiskLimits.aProductLimits)) {

                const instId = limit.iId
                const exchangeId = limit.iExchangeId
                const marketName = limit.iExchangeId && marketLookup[exchangeId] ? marketLookup[exchangeId].name : exchangeId
                const prodType = get_prod_type(limit.iProductTypeId)
                const maxPosProdNett = limit.iMaxPos
                const maxLongPosContract = limit.iMaxLongPosPerContract
                const maxShortPosContract = limit.iMaxShortPosPerContract
                const maxLongPositionGross = limit.iLong
                const maxShortPositionGross = limit.iLongShort
                const allowTradeOut = limit.bAllowTradeOut === 1 ? "Yes" : "No"
                const allowOutrightTrade = limit.bOutrightOn === 1 ? "Yes" : "No"
                const allowOutrightCancel = limit.bOutrightCancelOn === 1 ? "Yes" : "No"
                const outrightMaxOrderQuantity = limit.outrightMaxOrderQuantity
                const outrightAppliedMargin = limit.iOutrightAddMarginPct
                const spreadStrategyTradAllow = limit.bSprOn === 1 ? "Yes" : "No"
                const spreadStrategyMargin = limit.iSprAddMarginPct
                const spreadStrategyMaxOrderQty = limit.iSprMaxOrderQ
                const whOutrightTradeAllow = limit.bWhOutrightOn === 1 ? "Yes" : "No"
                const whOutrightCancelAllow = limit.bWhSprCancelOn === 1 ? "Yes" : "No"
                const whOutRightMaxOrderQty = limit.iWhOutrightMaxOrderQ


                tab_data4.push(
                    {
                        'uniqueId': prodLimitNo,
                        'instId': instId,
                        'exchangeId': marketName,
                        'prodType': prodType,
                        'maxPosProdNett': maxPosProdNett,
                        'maxLongPosContract': maxLongPosContract,
                        'maxShortPosContract': maxShortPosContract,
                        'maxLongPositionGross': maxLongPositionGross,
                        'maxShortPositionGross': maxShortPositionGross,
                        'allowTradeOut': allowTradeOut,
                        'allowOutrightTrade': allowOutrightTrade,
                        'allowOutrightCancel': allowOutrightCancel,
                        'outrightMaxOrderQuantity': outrightMaxOrderQuantity,
                        'outrightAppliedMargin': outrightAppliedMargin,
                        'spreadStrategyTradAllow': spreadStrategyTradAllow,
                        'spreadStrategyMaxOrderQty': spreadStrategyMaxOrderQty,
                        'spreadStrategyMargin': spreadStrategyMargin,
                        'whOutrightTradeAllow': whOutrightTradeAllow,
                        'whOutrightCancelAllow': whOutrightCancelAllow,
                        'whOutRightMaxOrderQty': whOutRightMaxOrderQty
                    }
                )
            }

        }

    }

    return (
        <Box pad="small">
            {Object.keys(limitSettings).length === 0 &&
                <>
                    <Text size="small" weight="bold" color="brand">Settings</Text>
                    <Box margin="xsmall" pad="xsmall" width="100"></Box>
                    <Warn warning="No Risk Settings" subWarning="No ApplyLimit values for the Selected Account+Environment in TTUS" />
                    <Box margin="xsmall" pad="xsmall" width="100"></Box>
                </>
            }

            {Object.keys(limitSettings).length > 0 &&
                <>
                    <Text size="small" weight="bold" color="brand">Settings</Text>
                    <Box margin="xsmall" pad="xsmall" width="100"></Box>
                    <Text size="xsmall"><Text size="xsmall" weight="bold">ApplyLimits:</Text> {limitSettings.applyLimits}</Text>
                    <Text size="xsmall"><Text size="xsmall" weight="bold">ApplyWholesaleLimits:</Text> {limitSettings.applyWholesaleLimits}</Text>
                    <Box margin="xsmall" pad="xsmall" width="100"></Box>
                </>
            }
            {tab_data4.length === 0 &&
                <>
                    <Text size="small" weight="bold" color="brand">Product Limits</Text>
                    <Box margin="xsmall" pad="xsmall" width="100"></Box>
                    <Warn warning="No Product Limits" subWarning="No Product Limits for the Selected Account+Environment in TTUS" />
                    <Box margin="xsmall" pad="xsmall" width="100"></Box>
                </>
            }
            {tab_data4.length > 0 &&
                <>
                    <Text size="small" weight="bold" color="brand">Product Limits</Text>
                    <AgDataTable
                        tab_col={tab_col4}
                        tab_data={tab_data4}
                        tableName="ProductLimitsV2"
                        showDetailedButton={false}
                    />
                </>
            }
        </Box>
    )
}

export default AccountRiskLimits